export default "__VITE_ASSET__CdGdPLZo__";